import type { SVGProps } from 'react';

/**
 * Stylized T-Rex silhouette (inspired by the iconic Jurassic Park logo
 * pose — original artwork drawn from scratch, not copied).
 * Use via `className` to control size / color with `currentColor`.
 */
export function TRexSilhouette(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M138 38 c-6 0 -14 3 -20 9 c-4 3 -8 9 -10 14 c-2 5 -3 12 -3 20 l-18 -2 c-8 -1 -16 0 -22 3 c-5 2 -10 6 -14 11 l-8 10 l8 2 c4 1 7 3 9 6 c2 3 3 7 3 11 l-2 10 c-1 4 -1 7 0 10 l2 6 l6 -2 c3 -1 6 -1 8 0 l4 2 l-1 6 c-1 5 0 9 2 12 c2 3 6 5 11 6 l9 1 l1 -8 c1 -6 3 -10 7 -13 c3 -2 8 -3 14 -3 l14 0 l0 8 c0 5 1 9 4 11 c3 2 7 3 13 3 l5 0 l-1 -10 c-1 -6 0 -11 3 -14 c2 -3 6 -5 11 -5 l7 0 l-2 -9 c-2 -8 -1 -16 3 -22 c3 -5 9 -9 18 -13 l6 -3 l-4 -4 c-6 -6 -14 -11 -22 -14 c-8 -3 -17 -5 -26 -5 l-5 0 l0 -8 c0 -8 -2 -14 -5 -17 c-3 -3 -7 -4 -11 -4 z M132 70 c2 0 4 1 5 3 c1 2 1 4 0 6 c-1 2 -3 3 -5 3 c-2 0 -4 -1 -5 -3 c-1 -2 -1 -4 0 -6 c1 -2 3 -3 5 -3 z" />
    </svg>
  );
}

/** Silhouette of velociraptor for secondary decoration. */
export function RaptorSilhouette(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 240 120"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M14 90 l10 -4 l18 -2 c8 -1 14 -4 18 -8 c3 -4 5 -9 5 -14 l2 -20 c1 -8 4 -14 8 -18 c5 -5 12 -8 22 -9 l12 -1 c8 0 14 2 19 6 c4 4 7 9 9 16 l2 8 l10 -6 c6 -4 12 -6 17 -7 c6 -1 11 0 16 2 c5 2 9 6 12 11 c3 5 5 11 6 18 l1 10 l16 -6 l-6 10 c-5 8 -10 13 -16 17 c-6 3 -13 5 -21 5 l-130 -1 l-30 -7 z M115 44 a3 3 0 1 1 -0.01 0 z" />
    </svg>
  );
}

/** Decorative amber caution chevron corner. */
export function CautionCorner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 40 40"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path d="M2 12 L2 2 L12 2" />
      <path d="M6 16 L6 6 L16 6" opacity="0.55" />
    </svg>
  );
}
